import { UPDATE_PRICING, CLEAR_PRICING } from '../actions/actionTypes';

export default (state = {}, action) => {
  switch (action.type) {
  case UPDATE_PRICING: {
    const { type, ...newState } = action;
    return newState;
  }
  case CLEAR_PRICING: {
    const { type, ...newState } = action;
    return newState;
  }
  default:
    return state;
  }
};
